import React, { useState } from 'react';
import { Star, Send } from 'lucide-react';
import { createReview } from '../services/reviewService';

interface ReviewFormProps {
  taxiStandId: string;
  onSuccess: () => void;
  onCancel: () => void;
}

export default function ReviewForm({ taxiStandId, onSuccess, onCancel }: ReviewFormProps) {
  const [rating, setRating] = useState(5);
  const [comment, setComment] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    try {
      await createReview(taxiStandId, rating, comment);
      onSuccess();
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Bir hata oluştu');
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      {/* Rating Stars */}
      <div>
        <label className="block text-sm text-gray-400 mb-2">Puanınız</label>
        <div className="flex items-center gap-1">
          {[1, 2, 3, 4, 5].map((value) => (
            <button
              key={value}
              type="button"
              onClick={() => setRating(value)}
              className="p-1 focus:outline-none focus:ring-2 focus:ring-yellow-400/20 rounded-lg"
            >
              <Star 
                className={`w-8 h-8 ${
                  value <= rating 
                    ? 'text-yellow-400 fill-current' 
                    : 'text-gray-600'
                }`}
              />
            </button>
          ))}
        </div>
      </div>

      {/* Comment */}
      <div>
        <label className="block text-sm text-gray-400 mb-2">Yorumunuz</label>
        <div className="relative">
          <textarea
            value={comment}
            onChange={(e) => setComment(e.target.value)}
            placeholder="Deneyiminizi paylaşın..."
            className="w-full bg-gray-900/50 text-white rounded-xl px-4 py-3 border border-white/10 focus:border-yellow-400/50 focus:ring-2 focus:ring-yellow-400/20 focus:outline-none placeholder-gray-500 resize-none"
            rows={4}
          />
        </div>
      </div>

      {error && (
        <div className="bg-red-500/10 border border-red-500/20 rounded-lg px-4 py-2 text-sm text-red-400">
          {error}
        </div>
      )}

      {/* Buttons */}
      <div className="flex justify-end gap-2">
        <button
          type="button"
          onClick={onCancel}
          className="px-4 py-2 text-gray-400 hover:text-white transition-colors"
        >
          İptal
        </button>
        <button
          type="submit"
          disabled={loading || !comment.trim()}
          className="flex items-center gap-2 px-6 py-2 bg-yellow-400 hover:bg-yellow-500 text-gray-900 font-medium rounded-lg transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
        >
          <Send className="w-4 h-4" />
          {loading ? 'Gönderiliyor...' : 'Gönder'}
        </button>
      </div>
    </form>
  );
}